module.exports = __webpack_public_path__ + "static/img/IMG_20240210_131214.06d668d6.jpg";